"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _download = _interopRequireDefault(require("./download.js"));
var _visualize = _interopRequireDefault(require("./visualize.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/** A package that exports a collection of generic column renderers for table */
var _default = exports["default"] = {
  download: _download["default"],
  visualize: _visualize["default"]
};